module.exports = __webpack_public_path__ + "img/hammer-war.fc8be27f.svg";